var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );
dependencies["../elements/plusminusinput.html"] = require( "../elements/plusminusinput.html" );
dependencies["./table.html"] = require( "./table.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/return.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/return.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += "\r\n";
env.getTemplate("../elements/plusminusinput.html", false, "views/content/return.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("plusminusinput", t_4);
output += "\r\n";
env.getTemplate("./table.html", false, "views/content/return.html", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("table", t_7);
output += "\r\n\r\n<div class=\"content\">\r\n\t<form class=\"form-view grid row\">\r\n\t\t";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"OnlyShowScan")) {
output += "\r\n\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Type"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t";
output += runtime.suppressValue((lineno = 11, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"type")])), env.opts.autoescape);
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Value"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t";
output += runtime.suppressValue((lineno = 20, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"value")])), env.opts.autoescape);
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\t\t";
;
}
output += "\r\n\r\n\t\t<div class=\"col col-xs-12 col-sm-6 col-md-3\">\r\n\t\t\t<label class=\"form-field\">\r\n\t\t\t\t<div class=\"form-label\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Scan"), env.opts.autoescape);
output += ":</div>\r\n\t\t\t\t<div class=\"form-input required-field\">\r\n\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"isSearch")) {
output += "\r\n\t\t\t\t\t";
output += runtime.suppressValue((lineno = 31, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"combobox")),"scan")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t<input name=\"scan\" class=\"editable-text ignore-next\" type=\"text\">\r\n\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</label>\r\n\t\t</div>\r\n\t</form>\r\n\r\n\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"rows")),"length") > 0) {
output += "\r\n\t<div class=\"table-view unsortable\">\r\n\t\t<form class=\"table-container\">\r\n\t\t\t<div class=\"table-index sticky-div\">\r\n\t\t\t\t<div class=\"table-row\">\r\n\t\t\t\t\t<!-- <div class=\"field checkbox selection-box\"><div class=\"ellipsis\"><input type=\"checkbox\" title=\"Select all\"></div></div> -->\r\n\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><div class=\"ellipsis\">\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"EnableSelectAll")) {
output += "\r\n\t\t\t\t\t\t<input type=\"checkbox\" title=\"Select all\">\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t</div></label>\r\n\t\t\t\t\t";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"columns");
if(t_12) {var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("col", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
output += "\r\n\t\t\t\t\t\t<div class=\"table-cell ";
output += runtime.suppressValue((runtime.memberLookup((t_13),"Type") == "Money" || runtime.memberLookup((t_13),"Type") == "Decimal" || runtime.memberLookup((t_13),"Type") == "Int"?"number " + runtime.memberLookup((t_13),"Type"):""), env.opts.autoescape);
output += "\" data-column=\"";
output += runtime.suppressValue(runtime.memberLookup((t_13),"Name"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_13),"Title"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<div class=\"ellipsis\">\r\n\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_13),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<!-- <div class=\"field\" title=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "i"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\"><input type=\"checkbox\"></div></div> -->";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"table-body bulkedit\">\r\n\t\t\t\t<div class=\"table-rows\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"rows");
if(t_16) {var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("row", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
var t_18;
t_18 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("index", t_18, true);
if(frame.topLevel) {
context.setVariable("index", t_18);
}
if(frame.topLevel) {
context.addExport("index", t_18);
}
output += "\r\n\t\t\t\t\t<div class=\"table-row\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_17),"used")),"ItemID"), env.opts.autoescape);
output += "\" data-rowid=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "index"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><input type=\"checkbox\" data-commit-checkbox=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" title=\"Select\" ";
output += runtime.suppressValue((runtime.memberLookup((t_17),"selected")?"checked":""), env.opts.autoescape);
output += "></label>\r\n\t\t\t\t\t\t<!--<div class=\"table-cell delete-row material-icons\" title=\"Verwijderen\"><div class=\"ellipsis\">&#xe5cd;</div></div>-->\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_21 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"columns");
if(t_21) {var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("col", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
if(runtime.memberLookup((t_22),"Name") == "Amount" && (!runtime.memberLookup((runtime.memberLookup((t_17),"old")),"IsSerial") || runtime.memberLookup((runtime.memberLookup((t_17),"used")),"AmountToReturn") > 1 || runtime.memberLookup((runtime.memberLookup((t_17),"used")),runtime.memberLookup((t_22),"Name")) == 0)) {
output += "\r\n\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 71, colno = 47, runtime.callWrap(runtime.memberLookup((t_4),"constructPlusMinusInput"), "plusminusinput[\"constructPlusMinusInput\"]", context, [t_22,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),runtime.memberLookup((runtime.memberLookup((t_17),"used")),runtime.memberLookup((t_22),"Name")),0,runtime.memberLookup((runtime.memberLookup((t_17),"used")),"AmountToReturn"),"table-cell field"])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 73, colno = 28, runtime.callWrap(runtime.memberLookup((t_7),"setColumnCell"), "table[\"setColumnCell\"]", context, [t_22,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),runtime.memberLookup((runtime.memberLookup((t_17),"used")),runtime.memberLookup((t_22),"Name")),runtime.contextOrFrameLookup(context, frame, "window"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((runtime.memberLookup((t_17),"editable")),runtime.memberLookup((t_22),"Name"))])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</form>\r\n\t</div>\r\n\t";
;
}
output += "\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/return.html"] , dependencies)